import React, { useState, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Print as PrintIcon,
  Close as CloseIcon,
  PictureAsPdf as PdfIcon
} from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import VoucherPrint from './VoucherPrint';

const VoucherPrintDialog = ({ open, onClose, voucher, companyInfo }) => {
  const printRef = useRef();
  const [loading, setLoading] = useState(false);

  const handlePrint = useReactToPrint({
      contentRef: printRef,
      documentTitle: `Voucher-${voucher?.voucherNumber || 'New'}`,
  });

  const handlePdfDownload = async () => {
    if (!printRef.current) return;
    
    setLoading(true);
    try {
      const element = printRef.current;
      const opt = {
        margin: 0.5,
        filename: `سند-${voucher?.voucherNumber || 'جديد'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
      
      await html2pdf().set(opt).from(element).save();
    } catch (error) {
      console.error('خطأ في تحميل PDF:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '80vh',
          direction: 'rtl'
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        معاينة الطباعة
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0, bgcolor: '#f5f5f5' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <Box sx={{ bgcolor: 'white', boxShadow: 3, maxWidth: '210mm', width: '100%' }}>
                <VoucherPrint ref={printRef} voucher={voucher} companyInfo={companyInfo} />
            </Box>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Tooltip title="طباعة">
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
            sx={{ minWidth: 120 }}
          >
            طباعة
          </Button>
        </Tooltip>
        
        <Tooltip title="تحميل PDF">
          <Button
            variant="outlined"
            startIcon={<PdfIcon />}
            onClick={handlePdfDownload}
            disabled={loading}
            sx={{ minWidth: 120 }}
          >
            {loading ? 'جاري التحميل...' : 'تحميل PDF'}
          </Button>
        </Tooltip>
        
        <Button onClick={onClose} color="inherit">
          إغلاق
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoucherPrintDialog;